/**
 * Admin Messenger Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import {
  MessengerMigrationRecordSchema,
  MessengerMigrationStatusResponseSchema,
  MigrateMessengerWebhookBodySchema,
  MigrateMessengerWebhookResponseSchema
} from "./schemas/messenger-migration.schemas";

export const ZAdminMessengerMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/messenger/status",
    Response: ApiSuccessSchema(MessengerMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/messenger/migrate",
    Body: MigrateMessengerWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateMessengerWebhookResponseSchema)
  }
} as const;

// ============================================================
// Convenience Type Exports
// ============================================================

export type MessengerMigrationRecord = z.infer<typeof MessengerMigrationRecordSchema>;
export type MessengerMigrationStatusResponse = z.infer<
  typeof MessengerMigrationStatusResponseSchema
>;
